var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.action)?_c('board',{attrs:{"boardId":_vm.id,"category":_vm.category}}):_c('board-form',{attrs:{"boardId":_vm.id,"action":_vm.action}})}
var staticRenderFns = []

export { render, staticRenderFns }